<div class="vision-card" [style.border-top-color]="overallColor()" (click)="cardClicked.emit(data())">
    <div class="vision-card__head">
        <img class="vision-card__logo" [src]="logo()" [attr.alt]="data()! | translateToken: 'name'" />
        <span class="vision-card__title">{{ data()! | translateToken: "name" }}</span>
    </div>

    <div class="vision-card__stats">
        @if (useIndicator().performance) {
            <div class="vision-card__metric">
                <div class="vision-card__metric-head">
                    <span class="vision-card__metric-label">{{ "landingPage.entity_page.annual_performance" | translate }}</span>
                    <span class="vision-card__metric-value" [style.color]="annualColor()">
                        @if (annualProgress() > 0) {
                            <adaa-count-up [total]="data().performance!" [fontSize]="valueFontSize" />
                        } @else {
                            {{ data().performance | percentageValue }}
                        }
                    </span>
                </div>

                <span
                    class="vision-card__bar"
                    role="progressbar"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [attr.aria-valuenow]="annualProgress()"
                    [attr.aria-label]="'landingPage.entity_page.annual_performance' | translate"
                >
                    <span [style.width.%]="annualProgress()" [style.background-color]="annualColor()"></span>
                </span>
            </div>
        }

        @if (useIndicator().visionAchievement) {
            <div class="vision-card__metric">
                <div class="vision-card__metric-head">
                    <span class="vision-card__metric-label">{{ "landingPage.entity_page.overall_performance" | translate }}</span>
                    <span class="vision-card__metric-value" [style.color]="overallColor()">
                        @if (overallProgress() > 0) {
                            <adaa-count-up [total]="data().visionAchievement!" [fontSize]="valueFontSize" />
                        } @else {
                            {{ data().visionAchievement | percentageValue }}
                        }
                    </span>
                </div>

                <span
                    class="vision-card__bar"
                    role="progressbar"
                    aria-valuemin="0"
                    aria-valuemax="100"
                    [attr.aria-valuenow]="overallProgress()"
                    [attr.aria-label]="'landingPage.entity_page.overall_performance' | translate"
                >
                    <span [style.width.%]="overallProgress()" [style.background-color]="overallColor()"></span>
                </span>
            </div>
        }
    </div>

    @if (useIndicator().ntkpiCount) {
        <div class="vision-card__footer">
            <span class="vision-card__targets">
                <i class="adaa-icon-console_kpis"></i>
                {{ "landingPage.entity_page.targets" | translate }}
                <strong>{{ data().ntKpiCount }}</strong>
            </span>
        </div>
    }
</div>
